/* ============================================================
   ONE STOCK CEILING, EVERYWHERE.

   Client, 2026-09-23: "the quantity selection ... must make sure that it
   would not go above the quantity we have in stock ... if they add 10 and
   we have just 3 they find that only at checkout, this needs to be forced
   across all website".

   WHY THIS IS ONE SHARED MODULE AND NOT FOUR SEPARATE FIXES: no storefront
   Ajax endpoint returns stock. /products/<handle>.js carries
   inventory_management but never inventory_quantity or inventory_policy,
   and /cart.js knows nothing about stock at all (both measured on this
   shop, 2026-09-23). The number exists ONLY in Liquid, at render time. So
   every Liquid render hands its ceilings to this module, the module keeps
   them for the session, and the controls that rebuild themselves from
   /cart.js - the basket drawer - ask it instead of guessing.

   A ceiling is recorded only for a variant that is TRACKED and DENIES
   overselling. A variant that keeps selling past zero has no ceiling, and
   inventing one would refuse a legitimate order.

   THIS IS THE ONLY GUARD. Measured on this shop, 2026-09-23: /cart/add.js
   answered HTTP 200 to every oversell tried, including 21 units of a variant
   with 1 in stock, and the basket held all 21. Shopify is refusing nothing
   here, so nothing catches a breach that gets past this file.
   ============================================================ */
(function () {
  'use strict';

  var STORE = 'tdhq:stock';
  var ceilings = {};   /* variant id -> units available, 0 meaning "no ceiling" */
  var inBasket = {};   /* variant id -> units the basket already holds */
  var basketAsked = false;

  try {
    var saved = window.sessionStorage.getItem(STORE);
    if (saved) { ceilings = JSON.parse(saved) || {}; }
  } catch (e) { ceilings = {}; }

  function keep() {
    try { window.sessionStorage.setItem(STORE, JSON.stringify(ceilings)); } catch (e) {}
  }

  function num(v) { var n = parseInt(v, 10); return isNaN(n) ? 0 : n; }

  /* A Liquid render telling us what it knows. Recording a 0 matters as much
     as recording a 3: it retires a ceiling remembered from an earlier page
     after the merchant stops tracking that variant. */
  function remember(id, units) {
    id = String(id || '');
    if (!id || id === '0') { return; }
    var n = num(units);
    if (ceilings[id] === n) { return; }
    ceilings[id] = n;
    keep();
  }

  /* null means "no ceiling": either nothing has told us about this variant,
     or it is one that keeps selling past zero. Both are handled the same
     way - we do not stand in the shopper's way. */
  function stock(id) {
    var n = ceilings[String(id || '')];
    return n > 0 ? n : null;
  }

  /* A battery kit built from its parts (owner + Simon, 20 Oct 2026) puts its PARTS in the basket, never itself, so
     its own line count is always 0. What the basket holds of a kit is counted from its parts instead, the cautious
     way: the part held most, in whole kits rounded up. Without this a second kit was offered on stock the first
     one had already taken. The parts list is the kit form's data-tdhq-kit-items. */
  function kitParts(id) {
    var forms = document.querySelectorAll('form[data-tdhq-kit-items]');
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i].elements ? forms[i].elements['id'] : null;
      if (!f || String(f.value) !== id) { continue; }
      var list = null;
      try { list = JSON.parse(forms[i].getAttribute('data-tdhq-kit-items') || ''); } catch (e) { list = null; }
      if (Array.isArray(list) && list.length) { return list; }
    }
    return null;
  }

  function held(id) {
    id = String(id || '');
    var parts = kitParts(id);
    if (!parts) { return num(inBasket[id]); }
    var most = 0;
    for (var i = 0; i < parts.length; i++) {
      var per = num(parts[i] && parts[i][1]);
      if (per > 0) { most = Math.max(most, Math.ceil(num(inBasket[String(parts[i][0])]) / per)); }
    }
    return most;
  }

  /* What may still be ADDED: the stock, less what the basket already holds.
     This is the half that the `max` attribute could never express, and the
     half the client's complaint is actually about. */
  function headroom(id) {
    var s = stock(id);
    if (s === null) { return null; }
    return Math.max(0, s - held(id));
  }

  function absorb(cart) {
    /* A failed or malformed read is not an empty basket. Keep the last confirmed quantities. */
    if (!cart || !Array.isArray(cart.items)) { return; }
    inBasket = {};
    if (cart && cart.items) {
      for (var i = 0; i < cart.items.length; i++) {
        var it = cart.items[i];
        var id = String(it.id);
        inBasket[id] = num(inBasket[id]) + num(it.quantity);
      }
    }
    repaint();
  }

  function readBasket() {
    basketAsked = true;
    return window.TdhqCart.get().catch(function () { return null; })
      .then(function (cart) { absorb(cart); return cart; })
      .catch(function () { return null; });
  }

  /* The drawer publishes the basket it just received, so the common case
     costs no request at all. */
  document.addEventListener('tdhq:cart:changed', function (e) {
    if (e.detail && e.detail.cart) { absorb(e.detail.cart); }
    else { readBasket(); }
  });

  /* ------------------------------------------------------------
     THE ONE CLAMP
     ------------------------------------------------------------ */

  /* `mode` is 'add' on a buy form, where what the basket already holds counts
     against the ceiling, or 'line' inside the basket, where the line's own
     quantity IS that basket quantity and only the stock applies. */
  function capFor(id, mode) {
    return mode === 'line' ? stock(id) : headroom(id);
  }

  function allowed(id, desired, mode, floor) {
    var min = num(floor);
    var want = Math.max(min, num(desired));
    var cap = capFor(id, mode);
    if (cap === null || want <= cap) { return { value: want, capped: false, cap: cap }; }
    return { value: Math.max(min, cap), capped: true, cap: cap };
  }

  /* Plain English, and never a sentence that reads wrong at one unit. */
  function reason(id, mode) {
    var s = stock(id);
    if (s === null) { return ''; }
    var have = mode === 'line' ? 0 : held(id);
    if (have <= 0) { return 'Only ' + s + ' in stock.'; }
    if (have >= s) {
      return s === 1
        ? 'The only one we have is already in your basket.'
        : 'Your basket already holds all ' + s + ' we have.';
    }
    return 'Only ' + s + ' in stock, ' + have + ' already in your basket.';
  }

  /* ------------------------------------------------------------
     THE CONTROLS
     ------------------------------------------------------------ */

  function variantOf(input) {
    var form = input.form || input.closest('form');
    /* form.elements, NOT querySelector. When the picker renders as cards the
       variant id is carried by `<input type="radio" name="id" form="...">`
       elements that live outside the <form> and are associated to it by the
       `form` attribute - querySelector cannot reach them, and on a radio
       group it would return the first radio rather than the checked one.
       form.elements sees form-associated controls wherever they sit, and a
       RadioNodeList's .value is the CHECKED radio's value. */
    var f = form && form.elements ? form.elements['id'] : null;
    if (f && f.value) { return String(f.value); }
    f = form && form.querySelector('[data-pdp-variant-id]');
    if (f && f.value) { return String(f.value); }
    /* A basket line: the line key's first segment is the variant id
       ("39072856015437:ecb5a8..."). */
    var holder = input.closest('[data-key]');
    var key = input.getAttribute('data-cart-qty') || (holder && holder.getAttribute('data-key'));
    return key ? String(key).split(':')[0] : '';
  }

  function modeOf(input) {
    return input.getAttribute('data-qty-mode') ||
      (input.name === 'quantity' ? 'add' : 'line');
  }

  /* WHERE THE SENTENCE GOES. Under the whole buy row, spanning the stepper
     and the Add button: the stepper's own column is 142px, where this wraps
     to four lines, and the buy row is a nowrap flex row, where appending
     makes it a squeezed third column. Measured at 628px it is one line. */
  function noteAnchor(input) {
    var row = input.closest('.dtc-pdp__buyrow, .tdhq-qv__buyrow');
    if (row && row.parentElement) { return { parent: row.parentElement, after: row }; }
    var line = input.closest('[data-cart-line], .dtc-cart__qtywrap, .dtc-cart__qtycell');
    /* in a basket line: beside the line's Remove, on its row */
    var rm = line && line.querySelector('.dtc-cart__remove');
    if (rm && rm.parentNode) { return { parent: rm.parentNode, after: rm }; }
    if (line) { return { parent: line, after: null }; }
    return { parent: input.parentElement, after: null };
  }

  function note(input, msg) {
    var at = noteAnchor(input);
    if (!at.parent) { return; }
    var box = at.parent.querySelector('[data-qty-note]');
    if (!msg) {
      if (box) { box.textContent = ''; box.hidden = true; }
      return;
    }
    if (!box) {
      box = document.createElement('p');
      box.className = 'tdhq-qtynote';
      box.setAttribute('data-qty-note', '');
      box.setAttribute('role', 'status');
      if (at.after && at.after.nextSibling) { at.parent.insertBefore(box, at.after.nextSibling); }
      else { at.parent.appendChild(box); }
    }
    var fresh = box.hidden || box.textContent !== msg;
    box.hidden = false;
    if (box.textContent !== msg) { box.textContent = msg; }
    if (fresh && window.TdhqMotion) { window.TdhqMotion.show(box); }
  }

  /* The "+" that belongs to this box, whatever the section calls it. */
  function plusOf(input) {
    var wrap = input.closest('.dtc-pdp__stepper, .dtc-cart__qty, .dtc-cart__qtywrap') || input.parentElement;
    if (!wrap) { return null; }
    var btns = wrap.querySelectorAll('[data-pdp-step], [data-cart-step]');
    for (var i = 0; i < btns.length; i++) {
      var s = btns[i].getAttribute('data-pdp-step') || btns[i].getAttribute('data-cart-step');
      if (num(s) > 0) { return btns[i]; }
    }
    return null;
  }

  /* Show the ceiling on the control: the "+" goes dead at the cap rather
     than accepting a press that does nothing. */
  function paint(input) {
    /* A product card's quantity is a hidden 1: nothing to show beside it.
       Its ceiling still clamps; the card's quick add says why on click. */
    if (!input || input.disabled || input.type === 'hidden') { return; }
    var id = variantOf(input);
    var mode = modeOf(input);
    var cap = capFor(id, mode);
    var plus = plusOf(input);
    if (plus && !plus.hasAttribute('data-qty-keep')) {
      plus.disabled = cap !== null && num(input.value) >= cap;
    }
    /* At the cap, say why. Below it, say nothing: a permanent "only 3 left"
       under every box is noise. Nor when the one unit left is the one in the
       box and the basket holds none: the buy box's stock line already says
       "Only 1 left", and the same fact twice in two wordings read as a
       fault (audit pdp-25). A basket line has no stock line, so it keeps it. */
    var said = mode === 'add' && held(id) === 0 && num(input.value) === 1 && cap === 1;
    if (cap !== null && num(input.value) >= cap && !said) { note(input, reason(id, mode)); }
    else { note(input, ''); }
  }

  function boxes() {
    return document.querySelectorAll(
      'input[name="quantity"], input[name="updates[]"], input[data-cart-qty]'
    );
  }

  function repaint() {
    var list = boxes();
    for (var i = 0; i < list.length; i++) { paint(list[i]); }
  }

  /* Ask for the basket the first time a page actually has a ceiling to
     enforce, not on every page load: this is a request, and the client
     judges the site on speed. */
  /* The basket drawer is drawn by the server with the page, so its lines ARE
     the basket this page was built with: each carries its line key (the
     variant id first) and its quantity. Counting them costs no request
     (audit cart-16); later changes arrive through tdhq:cart:changed. */
  function seedFromDrawer() {
    var drawer = document.querySelector('[data-tdhq-cart-drawer]');
    if (!drawer) { return false; }
    var map = {};
    var lines = drawer.querySelectorAll('[data-cd-item]');
    for (var i = 0; i < lines.length; i++) {
      var id = String(lines[i].getAttribute('data-key') || '').split(':')[0];
      var q = lines[i].querySelector('[data-cd-qtyval]');
      if (id) { map[id] = num(map[id]) + num(q ? q.textContent : 0); }
    }
    inBasket = map;
    basketAsked = true;
    return true;
  }

  function maybeReadBasket() {
    if (basketAsked) { return; }
    var list = boxes();
    for (var i = 0; i < list.length; i++) {
      if (modeOf(list[i]) === 'add' && stock(variantOf(list[i])) !== null) {
        if (!seedFromDrawer()) { readBasket(); }
        return;
      }
    }
  }

  function isQtyBox(el) {
    return el && el.matches &&
      el.matches('input[name="quantity"], input[name="updates[]"], input[data-cart-qty]');
  }

  /* TYPED NUMBERS, EVERYWHERE, IN ONE LISTENER. Delegated from the document
     so a box that arrives later - quick view, a re-rendered basket - is
     covered without being registered. `change` and `blur` do the clamping;
     `input` only repaints, so the shopper can clear the box and retype
     without the first digit being fought. */
  document.addEventListener('input', function (e) {
    if (isQtyBox(e.target)) { paint(e.target); }
  });

  /* A new variant is a new ceiling. */
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (el && el.name === 'id') { repaint(); }
  });

  function clampEvent(e) {
    var el = e.target;
    if (!isQtyBox(el)) { return; }
    var floor = el.hasAttribute('min') ? num(el.getAttribute('min')) : 1;
    var r = allowed(variantOf(el), el.value, modeOf(el), floor);
    if (String(r.value) !== String(el.value)) { el.value = r.value; }
    paint(el);
  }

  document.addEventListener('change', clampEvent, true);
  document.addEventListener('blur', clampEvent, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelectorAll) { return; }
    var list = form.querySelectorAll('input[name="quantity"], input[name="updates[]"], input[data-cart-qty]');
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      var floor = el.hasAttribute('min') ? num(el.getAttribute('min')) : 1;
      var r = allowed(variantOf(el), el.value, modeOf(el), floor);
      if (String(r.value) !== String(el.value)) { el.value = r.value; paint(el); }
    }
  }, true);

  /* After a refused or unconfirmed add of several lines (a battery kit's parts) Shopify may have added some of
     them: read the basket back so the header count, the drawer and every ceiling show what is really there. */
  function reconcile() {
    var d = window.tdhqCartDrawer;
    return Promise.resolve(d && d.refresh ? d.refresh() : readBasket()).then(function (cart) {
      if (!cart) { return null; }
      absorb(cart);
      var badges = document.querySelectorAll('[data-tdhq-cart-count]');
      for (var i = 0; i < badges.length; i++) {
        var sr = badges[i].querySelector('.tdhq-visually-hidden, .visually-hidden');
        badges[i].textContent = cart.item_count;
        if (sr) {
          badges[i].appendChild(sr);
          sr.textContent = cart.item_count === 1 ? 'item in basket' : 'items in basket';
        }
        badges[i].classList.toggle('tdhq-hidden', cart.item_count === 0);
      }
      return cart;
    }).catch(function () { return null; });
  }

  window.TdhqQty = {
    variantOf: variantOf,
    remember: remember,
    stock: stock,
    held: held,
    headroom: headroom,
    allowed: allowed,
    reason: reason,
    note: note,
    paint: paint,
    repaint: repaint,
    absorb: absorb,
    readBasket: readBasket,
    reconcile: reconcile
  };

  function start() {
    /* Every box that Liquid rendered with a `max` is a ceiling we now know. */
    var list = boxes();
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (el.hasAttribute('max')) { remember(variantOf(el), el.getAttribute('max')); }
    }
    maybeReadBasket();
    repaint();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else { start(); }
})();
